import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import MonthDropDown from "../../../../Enums/MonthDropDown";
import YearDropDown from "../../../../Enums/YearDropDown";
import { months } from "../../../../Enums/Fixed";
import FingerprintExclusionService from "../../../../../services/HRM/FingerprintExclusionService";

const UploadSheetModal = ({ modal, setModal }) => {
	const [file, setFile] = useState("");
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const fingerprintExclusionService = new FingerprintExclusionService();
	const [params, setParams] = useState({
		month: {
			label: Translate[lang][months[new Date().getMonth()].toLocaleLowerCase()],
			value: months[new Date().getMonth()],
		},
		year: {
			label: `${new Date().getFullYear()}`,
			value: new Date().getFullYear(),
		},
	});

	const submit = (e) => {
		e.preventDefault();
		let monthData =
			months?.findIndex((res) => res === params?.month?.value) + 1 > 9
				? months?.findIndex((res) => res === params?.month?.value) + 1
				: `0${months?.findIndex((res) => res === params?.month?.value) + 1}`;
		let data = {
			processingMonth: `${params?.year?.value}-${monthData}`,
		};

		setLoading(true);
		fingerprintExclusionService
			.postUploadSheet(file, data)
			?.then((res) => {
				if (res && res?.status === 201) {
					toast.success(res?.data?.message);
					setModal();
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	const changeParams = (e, name) => {
		setParams({ ...params, [name]: e });
	};

	const fileHandler = (e) => {
		let files = e.target.files;
		const filesData = Object.values(files);
		if (!!filesData?.length) {
			setFile(filesData[0]);
		}
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade addDepartment" : "ar fade addDepartment"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{Translate[lang]?.upload_sheet}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						<Col md={12}>
							<div className="form-group w-100">
								<label className="m-0">{Translate[lang]?.sheet}</label>
								<div className="upload">
									<input
										type="file"
										name="file"
										id="file"
										onChange={(e) => fileHandler(e)}
									/>
									<p>{Translate[lang].upload_sheet}</p>
									{!file ? (
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M12 15V3.62"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M15.35 5.85L12 2.5L8.65002 5.85"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									) : (
										<svg
											width="24"
											height="24"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
												fill="#21AA37"
											/>
										</svg>
									)}
								</div>
								{!!file && !loading && (
									<div className="banner_image profile-image mt-3 h-100">
										<i
											className="la la-file-pdf"
											style={{ fontSize: "7rem" }}
										/>
										{/* <a href={file} target="_blank" rel="noreferrer">
											<i className="la la-eye" />
										</a> */}
										<i
											className="la la-trash"
											style={{ right: "8px", top: "0" }}
											onClick={() => setFile("")}
										/>
									</div>
								)}
							</div>
						</Col>

						<Col md={6} sm={6}>
							<MonthDropDown params={params} changeParams={changeParams} />
						</Col>
						<Col md={6} sm={6}>
							<YearDropDown params={params} changeParams={changeParams} />
						</Col>
						<Col md={12}>
							<Button
								variant="primary"
								type="submit"
								className="w-100 mt-4"
								disabled={loading}>
								{Translate[lang]?.save}
							</Button>
						</Col>
					</Row>
				</Modal.Body>
			</AvForm>
		</Modal>
	);
};

export default UploadSheetModal;
